<template>
  <base-entity-card
    :id="id"
    titleName="готового решения"
    :saveFunc="save"
    :loading="loading"
    @closed="restoreEntity"
    :oneColumn="false"
  >
    <v-form ref="form" v-model="isValid">
      
      <v-text-field
        label="Название  *"
        v-model="entity.name"
        :rules="[v => !!v || 'Введите название.']"
        filled
      ></v-text-field>
      <v-text-field
        label="Категория"
        v-model="entity.category"
        filled
      ></v-text-field>
      <text-chips
        v-model="entity.textPoints"
        label="Описание решения"
      ></text-chips>
      <v-text-field
        class="mt-5"
        label="Название кнопки заказа"
        v-model="entity.btnText"
        filled
      ></v-text-field>
      <v-switch
        v-model="entity.priceFrom"
        :label="`Указана минимальная цена (от): ${entity.priceFrom ? 'да' : 'нет'}`"
      ></v-switch>
      <v-switch
        v-model="entity.modalBlock.isActive"
        :label="`Модальное окно: ${entity.modalBlock.isActive ? 'включено' : 'выключено'}`"
      ></v-switch>
      <template v-if="entity.modalBlock.isActive">
        <v-text-field
          label="Название ссылки для открытия окна"
          v-model="entity.modalBlock.openLinkText"
          :rules="[v => !!v || 'Введите название ссылки.']"
          filled
        ></v-text-field>
        <v-md-editor v-model="entity.modalBlock.htmlContent" height="400px" class="mb-3"></v-md-editor>
      </template>
     
    </v-form>
  </base-entity-card>
</template>

<script>
import SiteEntityMixin from '../../../models/SiteEntityMixin';

export default {
  name: 'site-solution-card',

  mixins: [SiteEntityMixin],

  data() {
    return {
      tag: 'solution'
    }
  },

  methods: {
    getDefaultEntity() {
      return {
        site: null,
        name: '', // Название готового решения - например: Капитальный ремонт
        textPoints: [], // Текстовое описание решения (элементы списка)
        priceFrom: false, // Показывает, выводим ли точную цену за Решение или "от"
        modalBlock: {
          isActive: false, // Активно ли модальное окно с доп. информацией
          openLinkText: '', // Текст открытия модального окна
          htmlContent: '', // HTML-содержимое модального окна
        },
        btnText: 'Заказать'
      }
    },
  },
}
</script>